// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__UVBZJ","column":"Dashboard_column__EnnS4","header":"Dashboard_header__q4dXn","box":"Dashboard_box__2NOBM"};